import { render, staticRenderFns } from "./FormStandardInput.vue?vue&type=template&id=01044299&scoped=true&"
import script from "./FormStandardInput.vue?vue&type=script&lang=js&"
export * from "./FormStandardInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01044299",
  null
  
)

export default component.exports